import React from 'react'
import useQueryFetchMe from '@hook/query/account/useQueryFetchMe'
import {useImportantAlertsContext} from '@hook/useImportantAlerts'
import UserThumbnail from '@component/images/UserThumbnail'
import IconNoticeRed from '@svg/common/ic_notice_red.svg'

interface IProps {
    className?: string
}

const UserAccountComponent = ({className}: IProps) => {
    const {data: me} = useQueryFetchMe()
    const {alertLength, settingAlertLength, proAlertLength, invoiceAlertLength} = useImportantAlertsContext()

    return (
        <div className={`cursor-pointer relative ${className}`} data-cy={'account_navigation'}>
            <UserThumbnail src={me?.thumbnail} size={24} isPro={me?.is_pro} />
            {alertLength + settingAlertLength + proAlertLength + invoiceAlertLength > 0 ? (
                <>
                    <IconNoticeRed
                        className={
                            'w-[14px] h-[14px] fill-red_shade dark:fill-dark_red_shade absolute bottom-[-1px] md:bottom-[-4px] left-[15px]'
                        }
                    />
                </>
            ) : null}
        </div>
    )
}
export default React.memo(UserAccountComponent)
